import React from "react";
import CenterCard from "../components/communityComp/CenterCard";
import { Paper, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../components/mainComponents/Header";
import { community } from "../data/";

const useStyles = makeStyles({
  gridItem: {
    display: "flex",
    justifyContent: "center",
    padding: "2rem",
  },
  paper: {
    height: "100%",
    paddingBottom: "10rem",
  },
  item: {
    height: "100%",
  },
});

const Commuinty = () => {
  const classes = useStyles();
  const renderCenters = [
    community.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <Grid item xs={12} className={classes.gridItem}>
            <CenterCard data={item} />
          </Grid>
        </React.Fragment>
      );
    }),
  ];
  return (
    <>
      <Paper className={classes.paper}>
        <Header headerText={"Our Community Centers"} />
        <Grid container>{renderCenters}</Grid>
      </Paper>
    </>
  );
};

export default Commuinty;
